module.exports = __webpack_public_path__ + "fanny-poing.png?dfc1ec8db729bb2b8d5de65b9e0326a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fanny-poing.png
// module id = 71
// module chunks = 0